module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting"
  }, [_c('div', {
    staticClass: "bg_f5f6f9"
  }), _vm._v(" "), _c('group', {
    staticClass: "block"
  }, [(_vm.supportedFunction.changeSocket) ? _c('cell', {
    attrs: {
      "is-link": "",
      "title": '连接的电器',
      "value": _vm.getPlugName(_vm.data.aligenieType).value
    },
    nativeOn: {
      "click": function($event) {
        _vm.showSelectClick('plug', _vm.getPlugName(_vm.data.aligenieType).key)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('cell', {
    attrs: {
      "is-link": _vm.supportedFunction.changeName,
      "title": '设备名称',
      "value": _vm.data.aligenieName || _vm.data.deviceName
    },
    nativeOn: {
      "click": function($event) {
        _vm.supportedFunction.changeName && _vm.showSelectClick('deviceName', _vm.data.aligenieName || _vm.data.deviceName)
      }
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "is-link": "",
      "title": '所在房间',
      "value": _vm.getRoomName(_vm.data.aligenieZone, _vm.data.roomName)
    },
    nativeOn: {
      "click": function($event) {
        _vm.showSelectClick('room', _vm.getRoomName(_vm.data.aligenieZone, _vm.data.roomName))
      }
    }
  })], 1), _vm._v(" "), _c('group', {
    staticClass: "block"
  }, [(_vm.supportedFunction.changeChannel) ? _c('cell', {
    attrs: {
      "is-link": "",
      "title": '频道信息',
      "link": '/settings/channel/list/?deviceId=' + _vm.data.deviceId
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn-square-primary btn-finish",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.finishClick
    }
  }, [_vm._v("完成")]), _vm._v(" "), (_vm.setting.deleteFunction) ? _c('button', {
    staticClass: "btn-operate-negative ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteClick
    }
  }, [_vm._v("\n      删除设备\n    ")]) : _vm._e()]), _vm._v(" "), _c('Selection', {
    ref: "selection",
    on: {
      "onChange": _vm.selectionChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-724f91c4"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/Index.vue
// module id = 908
// module chunks = 1